import VerticalPage from "@/components/VerticalPage";
import { MEDIA } from "@/lib/content";

export default function Aspire() {
  return (
    <VerticalPage
      overline="Aspire · Perspire · Inspire"
      title="The Vision. The Work. The Impact."
      subtitle="Aspire Perspire Inspire is the mindset and discipline platform behind the Moaglee ecosystem. Aspire is the vision. Perspire is the work. Inspire is the impact."
      image={MEDIA.waterfront}
      statement="Aspire is the vision. Perspire is the work. Inspire is the impact."
      bullets={[
        "The book & core discipline framework",
        "1:1 and group coaching",
        "Speaking & workshops",
        "The 90-day program",
        "Leadership & personal development",
      ]}
      redirectKey="aspire"
      redirectLabel="Visit AspirePerspireInspire.com"
      forms={["coaching"]}
      sourcePage="/aspire"
    />
  );
}
